import { useCallback, useState } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { PACKAGE_NAME } from '../../common/constants/index.tsx';
import type {
	ProjectTemplatesResponse,
	TemplatesV2Response,
	ProjectTemplatesState,
} from './types.tsx';
import { getFilteredTemplates, getFilteredTemplatesNew } from './utils.tsx';

const initialState = {
	data: {
		templates: null,
	},
	loading: false,
	error: null,
};

export const useProjectTemplates = (): ProjectTemplatesResponse => {
	const [{ loading, data, error }, setState] = useState<ProjectTemplatesState>(initialState);

	const fetch = useCallback(async () => {
		setState({
			data: {
				templates: null,
			},
			loading: true,
			error: null,
		});

		try {
			// GALILEO-1282 START
			const url = fg('grw-529_srtpmfy_experiment_kill_switch')
				? '/rest/simplified/2.0/project-templates?recommendations&templateGallery'
				: '/rest/simplified/2.0/project-templates?recommendations';
			// GALILEO-1282 END
			const response = await fetchJson<TemplatesV2Response>(url);

			const jwmTemplates = fg('productionise_msr_for_jsm_jpd_template_recos')
				? getFilteredTemplatesNew(response)
				: getFilteredTemplates(response);

			setState({
				data: {
					templates: jwmTemplates,
					recommendationSessionId: response.recommendationSessionId,
				},
				loading: false,
				error: null,
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (err: any) {
			fireErrorAnalytics({
				meta: {
					id: 'useProjectTemplates',
					packageName: PACKAGE_NAME,
					teamName: 'jira-warepil',
				},
				error: err,
				sendToPrivacyUnsafeSplunk: true,
			});

			setState({
				data: {
					templates: null,
				},
				loading: false,
				error: err,
			});
		}
	}, []);

	return { data, loading, error, fetch };
};
